import { RouteObject } from "react-router-dom-7"
import { routes as children } from "./routes"

export const routes: RouteObject[] = [
	{
		lazy: () => import("./layout"),
		children: [
			{ index: true, lazy: () => import("./pages/index") },
			...children
		]
	}
]
